<template>
    <div class="memorandum_info">
        <div class="vacation_data" v-if="parseInt(this.vacation.id) > 0">
            <div class="before_change">
                <legend>Період відпустки</legend>
                <b>з</b>{{this.vacation.from}} <b>по</b> {{this.vacation.to}}
            </div>
            <div>
                <div class="row mem_create_row pb-5 mb-5" >
                    <div xs="6" offset-xs="6" class="col-md-5 col-lg-5 col-xl-4 offset-md-7 offset-lg-7 offset-xl-8">
                        <button type="button" class="btn btn-lg btn-primary waves-effect waves-themed w-100" v-on:click="change_period">
                            <span  class="fal  fa-eject mr-1"></span>
                            Змінити період відпустки
                        </button>
                    </div>
                </div>
            </div>
            <edit_vacation></edit_vacation>
            <legend></legend>
        </div>
    </div>
</template>

<script>
import edit_vacation from "./edit_vacation/edit_vacation.vue";

export default {
    name: "mem_inside_vacation",
    components : {
        edit_vacation,
    },
    props : {
        "addon_data" : {
            type : Object
        },
        
        'mem' : {
            type : Object
        },
    },
    
    methods: {
        change_period() {
            this.vacation.doc_id = this.mem.id;
            EventBus.$emit('edit_vacation_period',this.vacation);
        }
    },
    
    computed : {
        vacation() {
            if(this.addon_data.hasOwnProperty('vacation')) {
                return this.addon_data.vacation;
            }
            return {
                "id" : 0,
            };
        },
    }
}
</script>


<style scoped>

</style>